export enum FieldTypes {
    Simple = 1,
    External = 2,
    Grid = 3,
    Spacer = 4,
    Panel = 5,
    ExternalList = 6,
    Custom = 10
}
